export default () => ({
  cartHeader: {
    width: '100%',
    height: '79px',
    borderBottom: '5px solid #658190',
  },
  cartHeaderLogo: {
    position: 'relative',
    marginLeft: '32px',
  },
  logo: {
    width: '82px',
    marginRight: '15px',
    marginTop: '10.5px',
    zIndex: '100',
    top: '-15px',
  },
  cartHeaderLabel: {
    fontFamily: 'Poppins',
    fontWeight: 300,
    fontSize: '26px',
    lineHeight: '107%',
    letterSpacing: '-2%',
    verticalAlign: 'middle',
    color: '#488400',
    margin: '30px 0px 0px 0px'
  },
  cartHeaderSubLabel: {
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '101%',
    letterSpacing: '1%',
  },
  headerInstructionAndActionBtn: {
    padding: '21px 32px 12px 32px',
    gap: '0px 30px',
  },
  descriptionContainer: {
    maxWidth: '1020px',
    fontFamily: 'Open Sans',
    fontSize: '16px',
    color: '#4B4B4B'
  },
  descriptionTitle: {
    color: '#27424E',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '130%',
    letterSpacing: '-1%',
    textTransform: 'uppercase', 
  },
  descriptionText: {
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: '0px',
    margin: '0px'
  },
  externalLinkIcon: {
    verticalAlign: 'middle'
  },
  keyword: {
    color: '#488400',
    fontFamily: 'Open Sans',
    fontWeight: 500
  }
});

